import $ from 'jquery'

const initModaal = function() {
  require(['modaal/dist/js/modaal.js', 'modaal/dist/css/modaal.min.css'], () => {
    $('.gallery').modaal({
      type: 'image',

    })
  })
}

$(document).ready(function(){
  initModaal()
})



// WEBPACK FOOTER //
// ./src/components/gallerymodal/index.js